import { fromJS } from 'immutable';
import { STAFF_PAGE_ACTIONS } from './actions';

export const initialState = fromJS({
  userData: {},
  allBusinessUnits: [],
  loading: false,
  phoneUpdateLoading: false,
  phoneUpdateRevision: 0,
  toastType: null,
  error: false,
});

export const staffPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case STAFF_PAGE_ACTIONS.SET_LOADING_STATUS: {
      return state.set('loading', payload);
    }

    case STAFF_PAGE_ACTIONS.SET_PHONE_UPDATE_LOADING: {
      return state.set('phoneUpdateLoading', payload);
    }

    case STAFF_PAGE_ACTIONS.FINISH_PHONE_UPDATE: {
      const nextState = state
        .set('phoneUpdateLoading', false)
        .update('phoneUpdateRevision', (revision) => revision + 1);
      if (payload === undefined) return nextState;

      return nextState.set('userData', {
        ...state.get('userData'),
        phone: payload,
      });
    }

    case STAFF_PAGE_ACTIONS.SHOW_ERROR: {
      return state.set('error', true);
    }

    case STAFF_PAGE_ACTIONS.SET_ONE_STAFF: {
      return state.set('userData', payload);
    }

    case STAFF_PAGE_ACTIONS.SET_STAFF_PAGE_BUSINESS_UNITS: {
      return state.set('allBusinessUnits', payload);
    }

    case STAFF_PAGE_ACTIONS.SHOW_TOAST: {
      return state.set('toastType', payload);
    }

    default: {
      return state;
    }
  }
};
